import { IProductLabel, IProductLabelWithMeta } from '@core/models/product.model';

/**
 * Returns true when the label was created by the frontend (e.g. promotion labels).
 * Use with applyProductLabelsVisibility to show only promotion labels.
 */
export function isPromotionLabel(label: IProductLabel): boolean {
  return (label as IProductLabelWithMeta)._meta?.origin === 'frontend';
}

/**
 * Applies a visibility rule to all product labels (immutable).
 * Iterates over each product's labels and sets visible = visibleWhen(label).
 * Use e.g. with isPromotionLabel to show only promotion labels, or pass () => true to keep all visible.
 */
export function applyProductLabelsVisibility<T extends { id: string; labels?: IProductLabel[] }>(
  products: T[] | undefined,
  visibleWhen: (label: IProductLabel) => boolean,
): T[] {
  if (!products?.length) {
    return products ?? [];
  }
  return products.map(p => {
    const labels = p.labels ?? [];
    if (!labels.length) {
      return p;
    }
    return {
      ...p,
      labels: labels.map(label => ({ ...label, visible: visibleWhen(label) })),
    };
  });
}
